'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _modal = require('redux/actions/modal');

var _pass_recovery = require('redux/actions/pass_recovery');

var _modal_type = require('redux/actions/modal_type');

var _BaseForm2 = require('../../BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassRecoveryStepOne = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        preload: state.auth.preload,
        passRecoveryError: state.passRecovery.error,
        shopId: state.setting.shopId,
        passRecoveryErrorCode: state.passRecovery.errorCode,
        lang: state.lang
    };
}, {
    hide: _modal.hide,
    sendCode: _pass_recovery.sendCode,
    showModalRegistration: _modal_type.showModalRegistration
}), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(PassRecoveryStepOne, _BaseForm);

    function PassRecoveryStepOne(props) {
        (0, _classCallCheck3.default)(this, PassRecoveryStepOne);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepOne.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepOne)).call(this));

        _this.onClickRegistration = function (event) {
            _this.props.showModalRegistration(_this.props.lang);
        };

        return _this;
    }

    (0, _createClass3.default)(PassRecoveryStepOne, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            event.preventDefault();
            this.props.sendCode(this.props.login, this.props.shopId);
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.props.login.length > 1;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('PassRecoveryStepOne', null, { folderName: 'PassRecovery/PassRecoveryStepOne' });

            return _react2.default.createElement(View, {
                changeFieldLogin: this.props.changeFieldLogin,
                disabledSubmit: !this.isValid(),
                onClickRegistration: this.onClickRegistration,
                onSubmit: this.onSubmit,
                login: this.props.login,
                preload: this.props.preload,
                error: this.props.passRecoveryError,
                errorCode: this.props.passRecoveryErrorCode,
                lang: this.props.lang
            });
        }
    }]);
    return PassRecoveryStepOne;
}(_BaseForm3.default), _class2.propTypes = {
    changeFieldLogin: _react.PropTypes.func,
    hide: _react.PropTypes.func.isRequired,
    login: _react.PropTypes.string.isRequired,
    sendCode: _react.PropTypes.func.isRequired,
    showModalRegistration: _react.PropTypes.func.isRequired,
    lang: _react.PropTypes.object
}, _class2.defaultProps = {
    changeFieldLogin: function changeFieldLogin() {}
}, _temp)) || _class);
exports.default = PassRecoveryStepOne;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepOne/PassRecoveryStepOne.jsx
// module id = 1720
// module chunks = 0